import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { FormHelper } from '../../helpers/form-helper';
import { FbError } from '../../models/fbError';
import { User } from '../../models/user';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends FormHelper implements OnInit, OnDestroy {

  constructor(private authService: AuthService,
							private formBuilder: FormBuilder,
							private router: Router,
							private userService: UserService) {
		super();

		this.buildForm();
	}

  ngOnInit() { }

	ngOnDestroy() { }

	public buildForm(): void {
		this.form = this.formBuilder.group({
			email: new FormControl('', [
				Validators.email,
				Validators.required
			]),
			password: new FormControl('', Validators.required)
		});
	}

	public async submitForm(): Promise<any> {
		try
		{
			let user: User = this.form.value;

			await this.authService.logIn(user);

			this.submitError = '';
			this.form.reset();
			this.router.navigate(['add-application']);
		}
		catch(ex)
		{
			let error = ex as FbError;

			switch (error.code) {
				case 'auth/invalid-email':
					this.submitError = 'El correo electrónico es incorrecto';
					break;

				case 'auth/user-disabled':
					this.submitError = 'El usuario ha sido deshabilitado';
					break;

				case 'auth/user-not-found':
					this.submitError = 'El usuario no ha sido encontrado';
					break;

				case 'auth/wrong-password':
					this.submitError = 'La contraseña es incorrecta';
					break;

				default:
					this.submitError = 'Ocurrió un error al iniciar sesión'
					break;
			}
		}
  }
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/login/login.component.ts